import React from 'react';
import styles from './Pagination.module.css';
import Button from '../Button/Button';

interface PaginationProps {
    page: number;
    pageCount: number;
    setPage: (page: number) => void;
    className?: string;
}

function getPages(current: number, total: number) {
    const delta = 2;
    const range = [];
    const rangeWithDots = [];
    let l: number | null = null;

    for (let i = 1; i <= total; i++) {
        if (i === 1 || i === total || (i >= current - delta && i <= current + delta)) {
            range.push(i);
        }
    }

    for (let i of range) {
        if (l !== null) {
            if (i - l === 2) {
                rangeWithDots.push(l + 1);
            } else if (i - l > 2) {
                rangeWithDots.push('...');
            }
        }
        rangeWithDots.push(i);
        l = i;
    }
    return rangeWithDots;
}

const Pagination: React.FC<PaginationProps> = ({
    page,
    pageCount,
    setPage,
    className = '',
}) => {
    if (pageCount <= 1) return null;

    const handlePrev = () => setPage(Math.max(1, page - 1));
    const handleNext = () => setPage(Math.min(pageCount, page + 1));
    const handlePage = (p: number) => setPage(p);

    const pages = getPages(page, pageCount);

    return (
        <div className={`${styles.pagingRow} ${className}`}>
            <Button
                size={'sm'}
                variant={'cancel'}
                className={`${styles.pagingBtn} ${styles.pagingNav}`}
                onClick={handlePrev}
                disabled={page === 1}
            >
                &lt; Prev
            </Button>
            {pages.map((p, idx) =>
                p === '...' ? (
                    <span key={`ellipsis-${idx}`} className={styles.pagingEllipsis}>...</span>
                ) : (
                    <Button
                        variant={'cancel'}

                        key={p}
                        size={'sm'}
                        className={styles.pagingBtn + (page === p ? ' ' + styles.pagingActive : '')}
                        onClick={() => handlePage(Number(p))}
                        disabled={page === p}
                    >
                        {p}
                    </Button>
                )
            )}
            <Button
                size={'sm'}
                variant={'cancel'}
                className={`${styles.pagingBtn} ${styles.pagingNav}`}
                onClick={handleNext}
                disabled={page === pageCount}
            >
                Next &gt;
            </Button>
        </div>
    );
};

export default Pagination;